import { render, staticRenderFns } from "./PageLieuxConsommation.vue?vue&type=template&id=2b9b7e0d&"
import script from "./PageLieuxConsommation.vue?vue&type=script&lang=js&"
export * from "./PageLieuxConsommation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports